// extracted by mini-css-extract-plugin
export var card = "_jf-5";
export var cardSelected = "_jf-4";
export var image = "_jf-3";
export var modal = "_jf-0";
export var modalContent = "_jf-1";
export var table = "_jf-2";